export default (function () {
    let MSBaseURL;
    return {
        getEndpoints: () => {
            return {
                // SPWebRootUrl,
                // WebRootSPURL,
                // MFE_ServiceRequest,
                MSBaseURL
                // SecureAPIBaseURL,
                // SignalrListenURL,
                // ISDLC_URL,
                // ERCSA_URL,
                // IPROCURE_URL,
                // ACCESS_CARD_URL,
                // HUB_PROXY
            }
        },
        initEndpoints: (Endpoints) => {
            // SPWebRootUrl = Endpoints['SP_ROOT'];
            // WebRootSPURL = Endpoints['SP_EWF'];
            // MFE_ServiceRequest = Endpoints['SR_WEB'];

            MSBaseURL = Endpoints['MS_ROOT'];
            // SecureAPIBaseURL = Endpoints['SECURE_API_ROOT'];
            // SignalrListenURL = Endpoints['SIGNALR_LISTEN_URL'];

            // ISDLC_URL = Endpoints['ISDLC_URL'];
            // ERCSA_URL = Endpoints['ERCSA_URL'];
            // IPROCURE_URL = Endpoints['IPROCURE_URL'];
            // ACCESS_CARD_URL = Endpoints['ACCESS_CARD_URL'];

            // HUB_PROXY = "MyChatHub";
        }
    }
})();